import './../textcss.css';
import * as React from 'react';
import { TextViewImpl } from '../textview';
import { TextComponentProps, TextComponentState } from '../textcomponent';
import { MsisdnTextCSSStyle } from './msisdntextcss';
import { Strings } from '../../../../utils/resources/strings';


export class MsisdnTextViewImpl extends TextViewImpl
{
    draw(props: TextComponentProps, state: TextComponentState, cssStyle: MsisdnTextCSSStyle): JSX.Element | boolean
    {   
         return (
                <div style={cssStyle.getWrapperCSSStyle()}>
                    {props.label !== "" && <label id="header-title" style={cssStyle.getTextLabelCSSStyle()}>{props.label}
                    {props.isRequired && !props.isDisabled && <label style={cssStyle.getLabelStartCSSStyle()}>
                           {"*"}
                        </label>}
                    </label>}
                    <div style={{display: "flex",width:'100%', flexFlow: "row nowrap", textAlign: "left"}}>
                         <label style={cssStyle.getCountryCodeCSSStyle()}>{props.context.getResources().getString(Strings.countrycode) + " - "}</label>
                        <input id="input-label" onKeyDown={this.onKeyPress} disabled={props.isDisabled}  value={state.value} type={props.inputType} onChange={this.onChange} style={state.errorMessage !== undefined ? cssStyle.getErrorCSSStyle() : cssStyle.getTextCSSStyle(state.class === "" ? false : true , props.isDisabled)} placeholder={props.hint}/>
                    </div>                

                    {
                        state.errorMessage !== undefined && <div style={cssStyle.getErrorTextDivCSSStyle()}>
                        <label style={cssStyle.getErrorTextCSSStyle(this.getContext().getUserContext().getLanguage())}>{state.errorMessage}</label> </div>}
                </div>
       );
    }

  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/text/msisdntext/msisdntextview.tsx